import { ForecastParamCode } from 'pleinchamp-api-client';
import React from 'react';
import { Text } from '@components/Text/Text.component';
import { Line } from '@icons/Line.icon';
import { getMetricWording, metricsWording } from '@meteo/business/forecastParamCodes.utils';
import { MetricsHelpIconButton } from '@meteo/components/MetricsHelpIconButton/MetricsHelpIconButton.component';
import { Breakpoint, useBreakpoint } from '@styles/breakpoints';
import { PlcColor } from '@styles/colors';
import style from '../MeteoWeatherTableContent.module.scss';

interface Props {
  forecastParam: ForecastParamCode;
  is15Days?: boolean;
  is36h?: boolean;
  isPro?: boolean;
}

function MeteoRowTitle({ forecastParam, is15Days, is36h, isPro }: Props) {
  let descKey: MetricWordingType = 'descHour';
  const breakPoint = useBreakpoint();

  let classname;

  if (!isPro && breakPoint === Breakpoint.m) {
    classname = style.tabletThWidth;
  }

  if (is15Days) {
    descKey = 'desc15d';
  }

  if (is36h) {
    descKey = 'desc36h';
  }

  const description = getMetricWording(forecastParam, descKey);

  return (
    <div className="flex align-center plc-pl-s">
      <Text className={classname} tag="div" variant="tag">
        {`${metricsWording[forecastParam].title} ${(() => {
          if (descKey === 'desc15d' && forecastParam === 'sunshineDuration') return '(h)';
          if (descKey === 'descHour' && forecastParam === 'sunshineDuration') return '(min)';
          return '';
        })()}`}
      </Text>
      {description && (
        <MetricsHelpIconButton title={metricsWording[forecastParam].title}>{description}</MetricsHelpIconButton>
      )}
      <Line fillColor={PlcColor.LIGHT_GREEN_2} />
    </div>
  );
}

export { MeteoRowTitle };
